/**
 * 드래그 가드 — 이 click 이 글 선택(드래그)의 끝이었나.
 * 줄 전체가 클릭인 목록(제품 목록 · 요청함 · 재고 실물)에서 파트넘버 · 디스크립션을 긁어 복사할 때 상세가 열리던 것(회의 2026-10-21 · 총괄).
 * 그냥 클릭은 mousedown 이 앞 선택을 풀어 click 땐 비어 있고, 긁은 뒤 손을 떼는 click 엔 선택 글이 남아 있다 — 이 하나로 가른다.
 * 빈 칸만 긁어 선택 글이 0자면 열린다 — 긁을 글이 없던 것.
 */
export function hasTextSelection(): boolean {
  const selection = window.getSelection();
  return selection !== null && selection.toString().length > 0;
}
